<!--
 * @Description: 
 * @Author: luckymiaow
 * @Date: 2023-03-09 11:43:07
 * @LastEditors: luckymiaow
-->
<!-- eslint-disable @typescript-eslint/no-unused-vars -->
<script setup lang="ts" name="SearchFormItem">
import { camelCase, upperFirst } from 'lodash-es';
import type { Component, VNode } from 'vue';
import { useSlots } from 'vue';
import useSlot from '../../hooks/useSlot';
import { BooleanSelect } from '../../boolean-select';
import { DatePicker } from '../../date-picker';
import { EnumRadio, EnumSelect } from '../../enum';
import { Input, InputSearch, Textarea } from '../../input';
import { InputMoney } from '../../input-money';
import { InputNumber } from '../../input-number';
import { InputPassword } from '../../input-password';
import { RangePicker } from '../../range-picker';
import { Select } from '../../select';
import { SelectPaged } from '../../select-paged';
import { StandardSelect } from '../../standard';
import { Switch } from '../../switch';
import { Cascader } from '../../cascader';
import type { FormBaseField } from '../types';

defineProps<{
  field: FormBaseField;
  model: { [key: string]: any };
}>();

const { useExcludeSlots } = useSlot({ slots: useSlots() }, []);

function getComponent(el: string | (() => VNode | JSX.Element) | Component) {
  if (typeof el === 'string') {
    const k = upperFirst(camelCase(el));
    const baseComponents: any = {
      BooleanSelect,
      DatePicker,
      EnumRadio,
      EnumSelect,
      Image,
      Input,
      InputSearch,
      Textarea,
      InputMoney,
      InputNumber,
      InputPassword,
      RangePicker,
      Select,
      SelectPaged,
      StandardSelect,
      Switch,
      Cascader,
    };
    if (k in baseComponents) return baseComponents[k];
  }
  return el;
}
</script>

<template>
  <!-- eslint-disable-next-line vue/no-mutating-props -->
  <component :is="getComponent(field.el)" v-if="field.prop" v-model:value="model[field.prop]" v-bind="field.attrs">
    <template v-for="(slot, key) in useExcludeSlots" :key="key" #[key]="scope">
      <slot :name="key" v-bind="scope ?? {}"> </slot>
    </template>
  </component>
  <component :is="getComponent(field.el)" v-else v-bind="field.attrs">
    <template v-for="(slot, key) in useExcludeSlots" :key="key" #[key]="scope">
      <slot :name="key" v-bind="scope ?? {}"> </slot> </template
  ></component>
</template>
